import { render, staticRenderFns } from "./LoginOptions.vue?vue&type=template&id=201b5a0a"
import script from "./LoginOptions.vue?vue&type=script&lang=ts"
export * from "./LoginOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports